import { lazy } from 'react';

const PasswordReset = lazy(() => import('./PasswordReset'));

export default PasswordReset;
